import { useEffect, useState } from "react";
import { acceptAll, getConsent, rejectAll, setConsent, subscribeConsent } from "@/lib/consent";

export function ConsentBanner() {
  const [decided, setDecided] = useState(true); // SSR-safe default; updated client-side
  const [showPrefs, setShowPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const sync = () => {
      const c = getConsent();
      setDecided(c.decided);
      setAnalytics(c.analytics);
      setMarketing(c.marketing);
    };
    sync();
    return subscribeConsent(sync);
  }, []);

  if (decided) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-2xl border border-border bg-card/95 p-4 shadow-glow backdrop-blur-xl md:p-5"
    >
      <p className="text-sm text-foreground">
        We use cookies to keep Glow Long working, understand site usage, and—if you choose—support
        marketing. Essential cookies are always active. Analytics and marketing cookies are
        optional. You can change your preferences at any time on our{" "}
        <a href="/legal/cookies" className="underline">cookies page</a>.
      </p>
      {showPrefs && (
        <div className="mt-3 grid gap-2 text-sm">
          <label className="flex items-center gap-2 opacity-60">
            <input type="checkbox" checked readOnly /> Essential (always on)
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} /> Analytics
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} /> Marketing
          </label>
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          onClick={acceptAll}
          className="rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-glow hover:opacity-90"
        >
          Accept
        </button>
        <button
          onClick={rejectAll}
          className="rounded-full border border-border bg-card px-4 py-2 text-sm font-medium hover:bg-secondary"
        >
          Reject
        </button>
        {showPrefs ? (
          <button
            onClick={() => setConsent({ analytics, marketing })}
            className="rounded-full border border-border bg-card px-4 py-2 text-sm font-medium hover:bg-secondary"
          >
            Save preferences
          </button>
        ) : (
          <button
            onClick={() => setShowPrefs(true)}
            className="rounded-full border border-border bg-card px-4 py-2 text-sm font-medium hover:bg-secondary"
          >
            Manage
          </button>
        )}
      </div>

    </div>
  );
}
